module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/self4.webp";